import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const DISCIPLINES = [
  {
    key: 'nursing',
    label: 'Nursing',
    subtitle: 'Critical thinking, case studies, pharmacology, and clinical stories',
    icon: '🩺',
    itemCount: 150,
    gradient: 'from-teal-500 to-emerald-600',
    available: true,
  },
  {
    key: 'medicine',
    label: 'Medicine',
    subtitle: 'Clinical cases, diagnostics, pharmacology, and emergencies',
    icon: '⚕️',
    itemCount: 100,
    gradient: 'from-blue-500 to-indigo-600',
    available: true,
  },
  {
    key: 'law',
    label: 'Law',
    subtitle: 'Case briefs, doctrine, issue-spotting, and exam prep',
    icon: '⚖️',
    itemCount: 100,
    gradient: 'from-amber-500 to-orange-600',
    available: true,
  },
] as const;

export function LearnPage() {
  const navigate = useNavigate();

  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="max-w-2xl mx-auto pb-20 space-y-4">
      <div>
        <h1 className="text-xl font-bold text-squishy-dark">Learn</h1>
        <p className="text-xs text-slate-500 mt-0.5">Deep-dive content to build real understanding</p>
      </div>

      <div className="space-y-3">
        {DISCIPLINES.map((d) => (
          <button
            key={d.key}
            onClick={() => d.available && navigate(`/learn/${d.key}`)}
            disabled={!d.available}
            className={`w-full text-left rounded-2xl overflow-hidden transition-all active:scale-[0.99] ${
              d.available
                ? 'hover:shadow-md cursor-pointer'
                : 'opacity-60 cursor-not-allowed'
            }`}
          >
            <div className={`bg-gradient-to-br ${d.gradient} p-5 relative`}>
              {!d.available && (
                <span className="absolute top-3 right-3 text-[10px] font-bold bg-white/20 text-white px-2.5 py-1 rounded-full uppercase tracking-wide">
                  Coming Soon
                </span>
              )}
              <div className="flex items-start gap-4">
                <span className="text-4xl">{d.icon}</span>
                <div className="flex-1 min-w-0">
                  <h2 className="text-lg font-bold text-white">{d.label}</h2>
                  <p className="text-sm text-white/80 mt-0.5 leading-snug">{d.subtitle}</p>
                  {d.available && d.itemCount > 0 && (
                    <div className="mt-3 flex items-center gap-2">
                      <span className="text-xs font-semibold text-white/90 bg-white/20 px-2.5 py-1 rounded-full">
                        {d.itemCount} items
                      </span>
                      <span className="text-xs text-white/60">Tap to explore</span>
                    </div>
                  )}
                </div>
                {d.available && (
                  <svg className="w-5 h-5 text-white/60 shrink-0 mt-1" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
                  </svg>
                )}
              </div>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
}
